import { gql } from '@apollo/client';

export const FLYER_FIELDS = gql`
  fragment flyerFields on Flyer {
    flyerId
    startDate
    endDate
    districtId
    schools {
      schoolId
      name
    }
    frontImageUrl
    isFavorite
    title
    criticalDate
    isRead
    status
    type
  }
`;

export const GET_NEW_FLYERS = gql`
  query getNewFlyers($input: GetNewFlyersInput!) {
    getNewFlyers(input: $input) {
      currentWeek {
        ...flyerFields
      }
      lastWeek {
        ...flyerFields
      }
    }
  }
  ${FLYER_FIELDS}
`;
